export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/~/d3-color/src/math.js
// module id = nUC3
// module chunks = 0